import { buildURI, useFetch } from '@hn-front/utils';
import { WEEKLY_REPORT_API } from '../../constants/routes';
import { adaptWeeklyReportToClient } from './adapter';
var useFetchWeeklyReportData = function (groupId, query) {
    return useFetch(buildURI(WEEKLY_REPORT_API.reportData, { pathParams: { groupId: groupId }, query: query }), { isCache: false, isStale: true, adapter: adaptWeeklyReportToClient });
};
export { useFetchWeeklyReportData };
